const e = {
  name: "ArrowCircleRightFilled",
  dimensions: { width: 22, height: 22 },
  content: `
     <path fill-rule="evenodd" clip-rule="evenodd" d="M22 11C22 4.93 17.07 -2.15497e-07 11 -4.80825e-07C4.93 -7.46153e-07 -2.15497e-07 4.93 -4.80825e-07 11C-7.46153e-07 17.07 4.93 22 11 22C17.07 22 22 17.07 22 11ZM10.29 15.71C10.09 15.51 10 15.26 10 15C10 14.74 10.1 14.49 10.29 14.29L12.58 12L6.99 12C6.44 12 5.99 11.55 5.99 11C5.99 10.45 6.44 10 6.99 10L12.58 10L10.29 7.71C9.9 7.32 9.9 6.69 10.29 6.3C10.68 5.91 11.31 5.91 11.7 6.3L15.7 10.3C15.79 10.39 15.87 10.5 15.92 10.63C16.02 10.87 16.02 11.15 15.92 11.39C15.87 11.51 15.8 11.62 15.7 11.72L11.7 15.72C11.31 16.11 10.68 16.11 10.29 15.72L10.29 15.71Z" fill="currentColor"/>
       `
};
export {
  e as ArrowCircleRightFilled
};
